export default __webpack_public_path__ + "static/media/warehouse-light.92bee771.svg";